module.exports = __webpack_public_path__ + "static/img/handshake.576be4d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/handshake.png
// module id = SmMU
// module chunks = 1